import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "primereact/carousel";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import {
  getCouponImages,
  deleteCouponImage,
  uploadCouponImages,
} from "../../../store/AsyncMethods/SetupMethod";
import { toast } from "react-toastify";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router-dom";

const ManageCoupon = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileUploadRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);

  const { images: backendImages, setupDetails } = useSelector(
    (state) => state.SetupReducer
  );

  const onFileUpload = () => {
    if (fileUploadRef.current) {
      const inputElement = fileUploadRef.current.getInput();
      inputElement.click();
    }
  };

  const onFileSelect = (e) => {
    const file = e.files[0];

    if (!file) {
      toast.error("File is invalid or exceeding size");
      return;
    }

    setImageUrl(file);
  };
  useEffect(() => {
    imageUrl && handleSubmit();
  }, [imageUrl]);

  useEffect(() => {
    if (setupDetails?.logoPath) {
      dispatch(getCouponImages());
    }
  }, [dispatch, setupDetails]);

  const itemTemplate = (image, index) => (
    <div className="image-item p-2 text-center" key={index}>
      <img
        src={`${setupDetails.logoPath}images/coupons/${
          image.filename || image
        }`}
        alt={`Coupon ${index + 1}`}
        className="img-fluid"
        style={{ maxHeight: "200px", objectFit: "contain" }}
      />
      <Button
        icon="pi pi-minus"
        label="Delete"
        className=" p-red-btn p-button-sm mt-2"
        onClick={() => handleDeleteImage(image)}
      />
    </div>
  );

  const handleDeleteImage = (image) => {
    if (backendImages.includes(image)) {
      dispatch(deleteCouponImage(image));
    }
  };

  const handleSubmit = () => {
    if (!imageUrl) {
      toast.error("No image selected");
      return;
    }

    dispatch(uploadCouponImages([imageUrl]));
    setImageUrl(null);
  };

  return (
    <div className=" ">
      <div className="card shadow-md rounded-lg p-4 ">
        <Divider>
          <span className="text-2xl font-bold p-font-style text-center text-black mx-1">
            Manage Coupons
          </span>
        </Divider>
        <Button
          onClick={() => {
            navigate("/site-setup");
          }}
          type="button"
          label="Back"
          icon="pi pi-arrow-left"
          className="  p-primary-highlight-btn"
        />
        <div className="flex flex-row-reverse  mb-3">
          <Button
            onClick={onFileUpload}
            type="button"
            label="Upload"
            icon="pi pi-plus"
            className="  p-primary-highlight-btn"
          />

          <FileUpload
            ref={fileUploadRef}
            mode="basic"
            name="coupon-upload"
            url="/api/upload-coupon"
            accept="image/*"
            maxFileSize={1000000}
            auto
            onSelect={onFileSelect}
            style={{ display: "none" }}
          />
        </div>

        <Carousel
          value={[...backendImages]}
          numVisible={3}
          numScroll={1}
          itemTemplate={itemTemplate}
          circular={false}
        />
      </div>
    </div>
  );
};

export default ManageCoupon;
